module.exports = __webpack_public_path__ + "components/MapControl/svg/Biblioteka.svg?0bea4093";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Biblioteka.svg
// module id = 1913
// module chunks = 0